import { useRef } from "react";

import { useStore } from "hooks/use-store";
import { useTrackWidget } from "hooks/use-analytics";
import { ScrollButtons } from "components/ui/scroll-buttons";
import { SafetyBlocks } from "./safety-blocks";
import { FuelBlocks } from "./fuel-blocks";
import { BasicBlocks } from "./basic-blocks";

export const Blocks = () => {
  const ref = useRef<HTMLDivElement>(null);

  // Speed mode toggles from the toolbar
  const safetySpeedEnabled = useStore((state) => state.safetySpeedEnabled);
  const ecoSpeedEnabled = useStore((state) => state.ecoSpeedEnabled);

  // Determine which mode is active based on the speed toggles
  const isCombinedMode = safetySpeedEnabled && ecoSpeedEnabled;
  const isEcoMode = !safetySpeedEnabled && ecoSpeedEnabled;
  const isSafetyMode = safetySpeedEnabled && !ecoSpeedEnabled;

  useTrackWidget(
    `blocks.${
      isCombinedMode
        ? "safety"
        : isEcoMode
        ? "fuel"
        : isSafetyMode
        ? "safety"
        : "basic"
    }`
  );

  // If both speeds are enabled, show safety blocks
  if (isCombinedMode) {
    return (
      <div ref={ref} className="flex-1 overflow-auto p-1">
        <SafetyBlocks />
        <ScrollButtons
          containerRef={ref}
          className="absolute bottom-4 right-4"
        />
      </div>
    );
  }

  // If only eco speed is enabled, show fuel blocks
  if (isEcoMode) {
    return (
      <div ref={ref} className="flex-1 overflow-auto p-1">
        <FuelBlocks />
        <ScrollButtons
          containerRef={ref}
          className="absolute bottom-4 right-4"
        />
      </div>
    );
  }

  // If only safety speed is enabled, show safety blocks
  if (isSafetyMode) {
    return (
      <div ref={ref} className="flex-1 overflow-auto p-1">
        <SafetyBlocks />
        <ScrollButtons
          containerRef={ref}
          className="absolute bottom-4 right-4"
        />
      </div>
    );
  }

  // If neither speed is enabled, show basic blocks
  return (
    <div ref={ref} className="flex-1 overflow-auto p-1">
      <BasicBlocks />
      <ScrollButtons containerRef={ref} className="absolute bottom-4 right-4" />
    </div>
  );
};
